var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "configValue-edit" },
    [
      _c("row-card", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.configModel.uiText))]
            },
            proxy: true,
          },
          {
            key: "value",
            fn: function () {
              return [
                !_vm.isEditable
                  ? _c("div", [
                      _vm._v(" " + _vm._s(_vm.configModel.value) + " "),
                    ])
                  : _c("div", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.editValue,
                            expression: "editValue",
                          },
                        ],
                        staticClass: "mb-2",
                        domProps: { value: _vm.editValue },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.editValue = $event.target.value
                          },
                        },
                      }),
                    ]),
              ]
            },
            proxy: true,
          },
          {
            key: "buttons",
            fn: function () {
              return [
                _c("div", { staticClass: "flex-row flex-1 buttons" }, [
                  _c("div", { staticClass: "flex-col flex-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "edit",
                        on: {
                          click: function ($event) {
                            return _vm.makeEditable()
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/icons/ic-plantparameters.svg"),
                            width: "auto",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }